import React from 'react'

import { Error } from '../errors'

export const ProtectionPermition = ({ children, permission = null }) => {
  return permission ? children : <Error.Permition />
}
